module.exports = __webpack_public_path__ + "static/media/water-bubbles.25df14ea.svg";